document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.hidden = !menu.hidden;
    });
  }
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.getElementById('MainImage');
      if (main) main.src = t.dataset.full;
    });
  });
});
